import { FC, PropsWithChildren } from 'react';

import { useHeapLoader } from '@/hooks/analytics/useHeapLoader';

export const HeapGateway: FC<PropsWithChildren> = ({ children }) => {
  useHeapLoader();

  return <>{children}</>;
};
